// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
.ManualReviewEvents .ag-full-width-row .ag-cell-wrapper.ag-row-group,
.ManualReviewEvents .ag-header-cell,
.ag-header-group-cell {
  padding-left: 16px;
}

.ManualReviewEvents .gridPageSize {
  padding-left: 0px;
}

.ManualReviewEvents .ag-cell {
  padding-left: 15px;
}

.ManualReviewEvents,
.ManualReviewEvents .aggridbasecomponent {
  height: 100%;
}

.ManualReviewEvents {
  display: grid;
  grid-template-rows: auto 1fr;
  height: calc(100% - 1rem);
  gap: 1vh;
  margin-block-start: 1rem;
}

.ManualReviewEvents .ag-theme-alpine .ag-cell.ag-cell-first-right-pinned {
  border-left: none;
}

.ManualReviewEvents .attachmentIcon {
  cursor: default;
}

.ManualReviewEvents .headerSection {
  display: grid;
  grid-template-rows: auto auto;
  /* row-gap: 1.7vh; */
}

.ManualReviewEvents .headerSection .divEvent {
  font-family: var(--default-FontName);
  font-size: var(--sub-header-FontSize);
  font-weight: var(--header-FontWeight);
  color: var(--default-FontColour);
  font-size: 24px;
  line-height: 32px;
  color: var(--default-FontColour);
  margin: 0px;
  /* adding custom height due to other tab has buttons with height 40 */
  height: 40px;
  display: flex;
  align-items: center;
}

.ManualReviewEvents .gridPageSizeHeader .gridRefreshDiv {
  margin: 0px;
}

@media (min-width: 1025px) and (max-width: 1360px) {
  .ManualReviewEvents {
    gap: 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/pages/manualReviewTab/features/manualReviewEvents/ManualReviewEvents.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,yBAAyB;EACzB,QAAQ;EACR,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,WAAW;EACX,qEAAqE;EACrE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,QAAQ;EACV;AACF","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n.ManualReviewEvents .ag-full-width-row .ag-cell-wrapper.ag-row-group,\n.ManualReviewEvents .ag-header-cell,\n.ag-header-group-cell {\n  padding-left: 16px;\n}\n\n.ManualReviewEvents .gridPageSize {\n  padding-left: 0px;\n}\n\n.ManualReviewEvents .ag-cell {\n  padding-left: 15px;\n}\n\n.ManualReviewEvents,\n.ManualReviewEvents .aggridbasecomponent {\n  height: 100%;\n}\n\n.ManualReviewEvents {\n  display: grid;\n  grid-template-rows: auto 1fr;\n  height: calc(100% - 1rem);\n  gap: 1vh;\n  margin-block-start: 1rem;\n}\n\n.ManualReviewEvents .ag-theme-alpine .ag-cell.ag-cell-first-right-pinned {\n  border-left: none;\n}\n\n.ManualReviewEvents .attachmentIcon {\n  cursor: default;\n}\n\n.ManualReviewEvents .headerSection {\n  display: grid;\n  grid-template-rows: auto auto;\n  /* row-gap: 1.7vh; */\n}\n\n.ManualReviewEvents .headerSection .divEvent {\n  font-family: var(--default-FontName);\n  font-size: var(--sub-header-FontSize);\n  font-weight: var(--header-FontWeight);\n  color: var(--default-FontColour);\n  font-size: 24px;\n  line-height: 32px;\n  color: var(--default-FontColour);\n  margin: 0px;\n  /* adding custom height due to other tab has buttons with height 40 */\n  height: 40px;\n  display: flex;\n  align-items: center;\n}\n\n.ManualReviewEvents .gridPageSizeHeader .gridRefreshDiv {\n  margin: 0px;\n}\n\n@media (min-width: 1025px) and (max-width: 1360px) {\n  .ManualReviewEvents {\n    gap: 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
